export type IStateHistoryService = StateHistoryService;
import { CommonUtilsService } from '../services/commonUtilsService';

export interface RouteState {
    id?:string;
    params: Object;
    name:string;
    url: string;
}

export class StateHistoryService {
    public static $inject =['utils'];
    private history:RouteState[] = [];
    private maxEntries:number = 5;

    public get length() {
        return this.history.length;
    }

    public get previous() {
        return this.history[this.history.length - 2];
    }

    public get oldest() {
        return this.history[0];
    }

    public get current(){
        return this.history[this.history.length - 1];
    }

    constructor(
        private readonly utils: CommonUtilsService
    ){
    }

    public push(state:RouteState, useParamsForUniqueness:boolean = true){
        let hashBase = state.name;
        if(useParamsForUniqueness){
            hashBase += ':' + JSON.stringify(state.params);
        }
        
        state.id = `stuid:${this.utils.generateHash(hashBase)}`;

        // only add a new entry if it's different than the most recent
        if(!this.current || state.id !== this.current.id){
            if(this.history.length === this.maxEntries) {
                this.history.shift();
            }
            
            this.history.push(state);
        }
    }

    public goBack(steps:number){
        var lastState:RouteState;
        if(steps > this.history.length) {
            steps = this.history.length;
        }

        while(steps--){
            this.history.pop();
        }

        return this.current;
    }

    public get(index:number){
        return this.history[index];
    }

    public setMaxEntries(numEntries:number){
        this.maxEntries = numEntries;
    }

    public clear(){
        this.history = [];
    }    
}


// WEBPACK FOOTER //
// ./src/util/services/stateHistoryService.ts